import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SpacingDemo from './SpacingDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, SpacingDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/spacing/demos/demo/SpacingDemo.tsx",
    "fileName": "SpacingDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nexport default function SpacingDemo() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={(theme) => ({\n          p: 1,\n          bgcolor: 'grey.50',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        p: 1\n      </Box>\n      <Box\n        sx={(theme) => ({\n          m: 1,\n          bgcolor: 'grey.50',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        m: 1\n      </Box>\n      <Box\n        sx={(theme) => ({\n          p: 2,\n          bgcolor: 'grey.50',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        p: 2\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 65,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nexport default function SpacingDemo() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        sx={(theme) => ({\n          p: 1,\n          bgcolor: 'grey.50',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        p: 1\n      </Box>\n      <Box\n        sx={(theme) => ({\n          m: 1,\n          bgcolor: 'grey.50',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        m: 1\n      </Box>\n      <Box\n        sx={(theme) => ({\n          p: 2,\n          bgcolor: 'grey.50',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        p: 2\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 65,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
